import React from 'react'
import { Flex, Text, Link } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { AiFillGithub, AiOutlineInstagram, AiFillLinkedin, AiOutlineMail, AiOutlineTwitter } from 'react-icons/ai'

const Tab = ({ label, idx, dt }) => {
    return (
        <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
                duration: 0.75,
                delay: dt,
                ease: "easeIn"
            }}
        >
            <Flex mr="2rem" textTransform="capitalize" color="text.light">
                <Text as={"span"} mr="1rem" color="primary.light">{`0${idx}.`}</Text>
                <Link
                    _focus={{ textDecoration: "none" }}
                    _hover={{
                        textDecoration: "none",
                        color: "primary.light"
                    }}
                    href='#about'
                >
                    {label}
                </Link>
            </Flex>
        </motion.div>
    )
}

const SocialIcon = ({ dt, icon, url }) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
                duration: 0.75,
                delay: dt,
                ease: "easeIn"
            }}
        >
            <Flex height="100%" justifyContent="center" alignItems="center" mr="1.5rem">
                <Link
                    _focus={{ textDecoration: "none" }}
                    _hover={{
                        textDecoration: "none",
                        color: "primary.light"
                    }}
                    href={url}
                >
                    {icon}
                </Link>
            </Flex>
        </motion.div>
    )
}

const Header = () => {
    return (
        <Flex w="100%" h="5rem" pt="1.5rem" px="2.5rem" mb="5rem" justifyContent="space-between" alignItems="center">
            <Flex>
                <SocialIcon url="https://github.com/chetas411" dt={0.75} icon={<AiFillGithub size={23} />} />
                <SocialIcon url="https://www.linkedin.com/in/chetas-sharma-184496167/" dt={0.85} icon={<AiFillLinkedin size={23} />} />
                <SocialIcon url="mailto:sharmachetas.111@gmail.com" dt={0.85} icon={<AiOutlineMail size={23} />} />
                <SocialIcon url="https://www.instagram.com/sharma_chetas411/" dt={0.85} icon={<AiOutlineInstagram size={23} />} />
                <SocialIcon url="https://twitter.com/chetas_sharma" dt={0.85} icon={<AiOutlineTwitter size={23} />} />
            </Flex>
            <Flex>
                <Tab label="about" idx={1} dt={0.75} />
                <Tab label="projects" idx={2} dt={0.85} />
                <Tab label="open source" idx={3} dt={0.95} />
            </Flex>
        </Flex>
    )
}

export default Header
